import axios from "axios";
import {router} from "@/router";

import {useUserStore} from "@/modules/User/store/user";
import {useGlobalModalsStore} from "@iflat-ui/stores/globalModals";
import {ROUTES} from "@/router/routerConst";

const getResponseErrorData = async ({request, response: {data}}) => {
  return (request.responseType === 'blob' && data instanceof Blob && data.type?.toLowerCase().includes('json'))
    ? JSON.parse(await data.text())
    : data
}

const showQueryErrorMessage = async err => {
  const data = await getResponseErrorData(err)

  const modalStore = useGlobalModalsStore()
  if(modalStore.alertModalConfig.isOpen) return

  const errors = data?.errors
  const title = errors ? 'Ошибка' : data?.message

  await new Promise((resolve) => {
    modalStore.openAlertModal(
      title,
      null,
      resolve,
      errors ? Object.values(errors).flat(Infinity) : []
    )
  })
}

const relogin = async () => {
  const userStore = useUserStore()
  if(userStore.loadingRefreshToken) return

  try {
    await userStore.refreshToken()
  } catch(e) {
    userStore.clearToken()
    await router.push({ name: ROUTES.LOGIN })
  }
}

axios.interceptors.response.use(response => response, async err => {
  if(err?.config?.hasInterceptor === false) return
  const userStore = useUserStore()

  const response = err.response
  const responseStatus = response?.status
  const statusesWithoutInterceptor = err?.config?.statusesWithoutInterceptor

  if (responseStatus && !statusesWithoutInterceptor?.includes(responseStatus)) {
    switch (responseStatus) {
      case 401:
        await relogin()
        break
      case 403:
        if (userStore.phone) {
          await router.replace({ name: ROUTES.REGISTRATION })
        } else {
          await router.replace({ name: ROUTES.LOGIN })
        }
        break
      case 404:
      case 400:
      case 422:
      case 500:
        await showQueryErrorMessage(err)
        break
    }
  }

  return Promise.reject(err);
})